/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const globalMessages = defineMessages({
    loading: {
        id: 'global.loading',
        defaultMessage: 'Loading ...'
    },
    cancel: {
        id: 'global.cancel',
        defaultMessage: 'Cancel'
    },
    learnMore: {
        id: 'global.learnMore',
        defaultMessage: 'Learn more'
    },
    cannotPerformAction: {
        id: 'global.cannotPerformAction',
        defaultMessage: 'Your role {displayedUserRole} does not have access to this feature'
    },
    cannotChangeSomeAppSettings: {
        id: 'global.cannotChangeSomeAppSettings',
        defaultMessage: 'Your role {displayedUserRole} cannot change some app settings or details.'
    },
    cannotAccessFeaturesOrPerformActions: {
        id: 'global.cannotAccessFeaturesOrPerformActions',
        defaultMessage: 'Your role {displayedUserRole} has access to limited features or actions on this page.'
    },
    learnMoreAboutAllowedFeature: {
        id: 'global.learnMoreAboutAllowedFeature',
        defaultMessage: 'Learn more about allowed features for your role.'
    },
    invalidRegion: {
        id: 'global.invalidRegion',
        defaultMessage: `{featureName} is only available in certain regions. The selected resource's region
        does not match the regions supported for this feature. See region availability
        for this feature and select another resource to proceed with project creation.`
    },
    cannotListLuisApps: {
        id: 'global.cannotListLuisApps',
        defaultMessage: 'You need to have a Cognitive Services LUIS role to list LUIS applications.'
    }
});
